import { Divider } from '@chakra-ui/react';
import Content from '@components/content';
import useOrder from '@hooks/useOrder';
import { useTranslation } from 'react-i18next';
import { LuCalculator } from 'react-icons/lu';
import { setComma, setCurrency } from 'utils/common';
import styles from '../order.module.scss';

export default function OrderStatement() {
  const {
    order: { cart, useCash, usePoint, coupon },
    productAmount,
    hotdealCount,
    promotionDiscount,
    deliveryFee,
    totalPrice,
    promotionConstant,
  } = useOrder();
  const { t } = useTranslation('store');

  return (
    <>
      {cart && (
        <section className={styles.orderStatementContainer}>
          <Content className="w-full">
            <div className="flex items-center justify-center gap-[10px]">
              <LuCalculator />
              <p className="font-bold text-[18px]">
                {t('calculate_payment_amount')}
              </p>
            </div>
            <table className="w-full my-[12px]">
              <tbody className="[&>tr]:last:border-b-collapse">
                <tr className="">
                  <td>{t('total_order_amount')}</td>
                  <td>{setCurrency('kr', setComma(productAmount))}</td>
                </tr>
                <tr>
                  <td>{t('total_delivery_fee')}</td>
                  <td>{setCurrency('kr', setComma(deliveryFee))}</td>
                </tr>
                {cart.store.isAllHotdeal && (
                  <>
                    {cart.store.isAllHotdeal === 2 ? (
                      <tr className="">
                        <td className="flex items-center gap-[4px] font-bold">
                          <p className="flex items-center gap-[6px]">
                            {t('hot_deals_title')}
                          </p>
                          <object
                            data="/static/icons/fire-svgrepo-com.svg"
                            className="h-[18px] w-[18px]"
                          />
                        </td>
                        <td className="text-primary-700 font-bold">
                          <span>-{setCurrency('kr', '1,000')}</span>
                        </td>
                      </tr>
                    ) : (
                      <>
                        {hotdealCount > 0 && (
                          <tr className="">
                            <td className="flex items-center gap-[4px] font-bold">
                              <p className="">{t('hot_deals_title')}</p>
                              <object
                                data="/static/icons/fire-svgrepo-com.svg"
                                className="h-[18px] w-[18px]"
                              />
                            </td>
                            <td className="text-primary-700 font-bold">
                              {cart.store.isAllHotdeal === 1 ? (
                                <span>
                                  -
                                  {setCurrency(
                                    'kr',
                                    setComma(hotdealCount * 1000),
                                  )}
                                </span>
                              ) : (
                                <span>-{setCurrency('kr', '1,000')}</span>
                              )}
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </>
                )}
                {promotionDiscount > 0 ? (
                  <tr>
                    <td className="flex items-center font-bold">
                      <p className="flex items-center gap-[6px]">
                        Promotion Event
                      </p>
                      <object
                        data="/static/icons/fire-svgrepo-com.svg"
                        className="h-[18px] w-[18px]"
                      />
                    </td>
                    <td className="text-primary-700 font-bold">
                      -{setCurrency('kr', setComma(promotionDiscount))}
                    </td>
                  </tr>
                ) : (
                  ''
                )}
                {promotionConstant > 0 ? (
                  <tr>
                    <td className="flex items-center font-bold">
                      <p className="flex items-center gap-[6px]">
                        {t('panther:instant_discount')}
                      </p>
                      <object
                        data="/static/icons/fire-svgrepo-com.svg"
                        className="h-[18px] w-[18px]"
                      />
                    </td>
                    <td className="text-primary-700 font-bold">
                      -{setCurrency('kr', setComma(promotionConstant))}
                    </td>
                  </tr>
                ) : (
                  ''
                )}
                {useCash && useCash > 0 ? (
                  <tr>
                    <td>
                      <p className="flex items-center gap-[6px] font-bold">
                        Panther Cash
                      </p>
                    </td>
                    <td className="text-primary-700 font-bold">
                      -{setCurrency('kr', setComma(useCash || 0))}
                    </td>
                  </tr>
                ) : (
                  ''
                )}
                {usePoint && usePoint > 0 ? (
                  <tr>
                    <td>
                      <p className="flex items-center gap-[6px] font-bold">
                        {t('point')}
                      </p>
                    </td>
                    <td className="text-primary-700 font-bold">
                      -{setCurrency('kr', setComma(usePoint || 0))}
                    </td>
                  </tr>
                ) : (
                  ''
                )}
                {coupon && coupon.amount > 0 ? (
                  <tr>
                    <td>
                      <p className="flex items-center gap-[6px] font-bold">
                        Coupon
                      </p>
                    </td>
                    <td className="text-primary-700 font-bold">
                      -{setCurrency('kr', setComma(coupon.amount || 0))}
                    </td>
                  </tr>
                ) : (
                  ''
                )}
              </tbody>
            </table>
            <Divider />
            <div className="my-[12px]">
              <dl className="font-bold text-[#000] text-[20px]">
                <dt>{t('amount_due_label')}</dt>
                <dd>{setCurrency('kr', setComma(totalPrice))}</dd>
              </dl>
            </div>
          </Content>
        </section>
      )}
    </>
  );
}
